<template>

  <div
    class="card">
    <div class="card-body">
      <highcharts
        :options="chartOptions">
        </highcharts>
    </div>
  </div>

</template>

<script>
import {Chart} from 'highcharts-vue'

export default {
  name: 'JobReport',
  components: {
    highcharts: Chart
  },
  props: {
    grid: {
      type: Array,
      default: () => { return [] }
    }
  },
  data () {
    return {
    }
  },
  computed: {
    chartOptions () {
      return {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: 'pie'
        },
        lang: {
          noData: this.$t('No data to display')
        },
        title: {
          text: this.$t('Disqualify reasons')
        },
        tooltip: {
          pointFormat: '{point.y}<br><b>{point.percentage:.1f}%</b>'
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              format: '<b>{point.name}</b>: {point.y} ({point.percentage:.1f}%)'
            }
          }
        },
        series: [{
          data: this.grid.map((v) => {
            return {
              name: v.name,
              y: v.total_placements
            }
          })
        }]
      }
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Job/JobReport/JobReportDisqualify.vue